
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

interface MobileNavButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export default function MobileNavButton({ isOpen, onClick }: MobileNavButtonProps) {
  return (
    <Button
      variant="outline"
      size="icon"
      className="md:hidden ml-1 border border-border rounded-md"
      onClick={onClick}
      aria-expanded={isOpen}
    >
      {isOpen ? (
        <X className="h-[1.2rem] w-[1.2rem]" />
      ) : (
        <Menu className="h-[1.2rem] w-[1.2rem]" />
      )}
      <span className="sr-only">{isOpen ? 'Close menu' : 'Open menu'}</span>
    </Button>
  );
}
